import { useState, useContext, useEffect } from "react";
import { Link } from "react-router-dom";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {
  faFileInvoice,
  faUserGroup,
  faBoxesPacking,
  faUserFriends,
  faUserTie,
  faDollar,
  faRedo,
  faVanShuttle,
  faStore,
  faObjectGroup,
  faShieldHalved,
  faScrewdriverWrench,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { AppStorage } from "../Utils/Context/AppContext";
import { useTranslation } from "react-i18next";
import SideBarRole from "./SideBarRole";

function SideBarList({ open }) {
  const [navItems, setNavItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const AppContext = useContext(AppStorage);
  const { t, i18n } = useTranslation();

  const links = [
    {
      title: "Maintenance Mode",
      path: "/maintenance-mode",
      access: ["admin"],
      icon: faScrewdriverWrench,
    },
    {
      title: `${t("Invoices")}`,
      path: "/invoices",
      access: ["admin", "user", "sub-admin"],
      icon: faFileInvoice,
    },
    {
      title: `${t("Users")}`,
      path: "/allUsers",
      access: ["admin", "sub-admin"],
      icon: faUserGroup,
    },
    {
      title: `${t("Sub Admin")}`,
      path: "/allSubAdmin",
      access: ["admin"],
      icon: faUserTie,
    },
    {
      title: `${t("Clients")}`,
      path: "/allClients",
      access: ["user"],
      icon: faUserFriends,
    },
    {
      title: `${t("Products")}`,
      path: "/allProducts",
      access: ["user"],
      icon: faBoxesPacking,
    },
    {
      title: `${t("Price Offer")}`,
      path: "/allOfferPrice",
      access: ["user"],
      icon: faDollar,
    },
    {
      title: `${t("All Sales Return")}`,
      path: "/allSalesReturn",
      access: ["user"],
      icon: faRedo,
    },
    {
      title: `${t("All Suppliers")}`,
      path: "/allSuppliers",
      access: ["user"],
      icon: faVanShuttle,
    },
    {
      title: `${t("All Purchases")}`,
      path: "/allSupplierInvoice",
      access: ["user"],
      icon: faStore,
    },
    {
      title: `${t("Invoice Templates")}`,
      path: "/templateList",
      access: ["admin"],
      icon: faObjectGroup,
    },
    {
      title: `${t("ZATCA Integration")}`,
      path: "/zatcaIntegration",
      access: ["user", "admin"],
      icon: faShieldHalved,
      zatcaPhase2Only: true,
    },
  ];

  useEffect(() => {
    if (AppContext?.userInfo) {
      const userRole = AppContext.userInfo.role;
      const userPhase = Number(AppContext.userInfo?.zatca_phase || 1);
      const filteredItems = links.filter((item) => {
        if (!item.access.includes(userRole)) return false;
        if (item.zatcaPhase2Only && userPhase !== 2) return false;
        return true;
      });
      setNavItems(filteredItems);
      setIsLoading(false);
    }
  }, [AppContext?.userInfo, i18n.language]);
  if (isLoading) {
    return null; 
  }
  return <SideBarRole navItems={navItems} open={open} />;
}

export default SideBarList;
